import React from "react";
import { About } from "../../../components/Others/Layout/About";
import { Footer } from "../../../components/SpearParts/Layouts/Footer";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Axios from "../../../axios/axios";

export const getCompleteData = async (
  setBuildingModels,
  setBuildingBrand,
  setBuildingCategory
) => {
  try {
    const response = await Axios.get("/type-based-details");
    console.log("API Response:", response.data);
    setBuildingModels(response.data.building.models);
    setBuildingBrand(response.data.building.brands);
    setBuildingCategory(response.data.building.categories);
  } catch (error) {
    console.error("Error fetching building details:", error);
  }
};

export const getItems = async (setRegion) => {
  try {
    const response = await Axios.get("/regions");
    console.log(response.data);
    setRegion(response.data);
  } catch (error) {
    console.log(error);
  }
};

export const getYears = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: currentYear - 1990 + 1 }, (_, i) => 1990 + i);
};

export const searchPart = async (filters, page = 1, limit = 10) => {
  try {
    const query = new URLSearchParams({ ...filters, page, limit,subcategoryId: filters.subcategoryId, }).toString();
    const response = await Axios.get(`/meterials/search?${query}`);

    return response.data; // ✅ Now returns {data, totalCount, totalPages, currentPage}
  } catch (error) {
    console.error("Error fetching parts:", error.response || error.message);
    return { data: [], totalCount: 0, totalPages: 0, currentPage: 1 };
  }
};


export const getFieldValues = async () => {
  try {
    const response = await Axios.get("/buildings/field-values");
    console.log("Field Values:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching field values:", error);
    throw error;
  }
};

function OtherHome() {
  const [buildingModels, setBuildingModels] = useState([]);
  const [buildingBrand, setBuildingBrand] = useState([]);
  const [buildingCategory, setBuildingCategory] = useState([]);
  const [buildingRegion, setBuildingRegion] = useState("");
  const [region, setRegion] = useState([]);

  useEffect(() => {
    getCompleteData(setBuildingModels, setBuildingBrand, setBuildingCategory);
    getItems(setRegion);
  }, []);

  useEffect(() => {
    getFieldValues();
  }, []);

  return (
    <>
      <About />
      {/* <Footer/> */}
    </>
  );
}

export default OtherHome;
